import React, { useState } from "react";
import { FPaquetesStyle } from "./styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import useCatalogos from "../../../hooks/useCatalogos";
import { useDispatch } from "react-redux";
import { altaGaleriaPaqueteAction } from "../../../ducks/paqueteDuck";
import { ToastMessage } from "../../../global/ToastMessage";
import UploadInput from "./../../../global/UploadInput";
import { getBase64 } from "./../../../utils/fileBase64";
import BackDrop from "./../../../global/BackDrop";
import Galeria from "./galeria";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "../../../global/ModalBase";
const FPaquetesGaleria = (props) => {
  const { open = true, setOpen = () => {}, rowData = {} } = props;
  const classes = FPaquetesStyle();
  const catTipoImagenes = useCatalogos("TipoImagen");
  const [idTipoImagen, setIdTipoImagen] = useState(0);
  const [file, setFile] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [isGaleria, setIsGaleria] = useState(false);
  const dispatch = useDispatch();
  const onGuardar = () => {
    if (file.length > 0) {
      setIsLoad(true);
      file.forEach(async (archivo) => {
        await getBase64(archivo).then((result) => {
          const Logobase64 = String(result).split(",")[1];
          let payload = {
            IdPaquete: rowData.IdPaquete,
            ClavePaquete: rowData.ClavePaquete,
            TipoImagen: {
              IdTipoImagen: idTipoImagen,
            },
            ImagenBase64: Logobase64,
            ExtensionImagen:
              archivo.name.split(".")[archivo.name.split(".").length - 1],
          };
          dispatch(altaGaleriaPaqueteAction(payload)).then((Response) => {
            switch (Response.status) {
              case 500:
                ToastMessage.fire({
                  icon: "error",
                  title: "Ha habido un problema de conexión con el servidor",
                });
                break;
              case 400:
                ToastMessage.fire({
                  icon: "warning",
                  title: "<strong>Atención</strong>",
                  text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                });
                break;
              default:
                setIsLoad(false);
                LimpiarForm();
                ToastMessage.fire({
                  icon: "success",
                  title: "Ingreso Correcto",
                });
                break;
            }
          });
        });
      });
    } else {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "Seleccione por lo menos una imagen.",
      });
    }
  };
  const LimpiarForm = () => {
    setIdTipoImagen(0);
    setFile([]);
  };
  const handleClose = () => {
    setOpen(!open);
    LimpiarForm();
  };
  const handleSelecTipoImagen = (event) => {
    setIdTipoImagen(event.target.value);
  };
  const onGaleria = () => {
    setIsGaleria(!isGaleria);
  };
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        titulo={`Galeria para el paquete ${rowData.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12}>
          {isGaleria && <Galeria idPaquete={rowData.IdPaquete} clavePaquete={rowData.ClavePaquete} />}
          {!isGaleria && (
            <Grid container className={classes.containerSpacing}>
              <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="lTipoImagen">Imagen</InputLabel>
                  <Select
                    labelId="lTipoImagen"
                    id="STipoImagen"
                    name="tipoImagen"
                    value={idTipoImagen}
                    onChange={handleSelecTipoImagen}
                    label="Vuelo"
                  >
                    <MenuItem value="0" disabled>
                      {"Seleccione una opción"}
                    </MenuItem>
                    {catTipoImagenes.map((item, index) => (
                      <MenuItem
                        key={item.IdTipoImagen}
                        value={item.IdTipoImagen}
                      >
                        {`${item.Descripcion}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {idTipoImagen > 0 && (
                  <UploadInput files={file} setFiles={setFile} />
                )}
              </Grid>
              <Grid item xs={12} className={classes.modalBotonesCenter}>
                <Button
                  onClick={onGuardar}
                  variant="contained"
                  color="primary"
                  className={classes.modalBoton}
                  disabled={file.length > 0 ? false : true}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotones}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
          <Button
            onClick={onGaleria}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            {!isGaleria ? "Ver galeria" : "Nuevas imagnes"}
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default FPaquetesGaleria;
